import { api } from "./client";

interface UserInfo {
  id: string;
  email: string;
  role: string;
  name: string | null;
  allow_external_send: boolean;
  is_super_admin: boolean;
}

interface LoginResponse {
  token: string;
  expiresAt: string;
  user: UserInfo;
}

export const authApi = {
  login: (email: string, password: string) =>
    api.post<LoginResponse>("/api/auth/login", { email, password }),

  logout: (_token: string) => api.post<{ ok: boolean }>("/api/auth/logout", {}),

  me: () => api.get<UserInfo>("/api/auth/me"),
};
